var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"color":"transparent","height":"100%","width":"100%"}},[(_vm.loading)?_c('Loading'):_c('div',[_c('Slides'),_c('About'),_c('Brands')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }